// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/between-horizontal-start.js';

import { paths } from '../generated/between-horizontal-start';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('between-horizontal-start', Original, paths);
